
































































































































































































import {
    Component,
    Prop,
    Vue,
} from 'vue-property-decorator';
import {
    State,
    Mutation,
    namespace,
} from 'vuex-class';

import DescriptionList from '@/components/descriptionlist/DescriptionList.vue';
import Description from '@/components/descriptionlist/Description.vue';

import moment from 'moment';
import axios from 'axios';

/**
 * 高级详情页
 */
@Component({
    components: {
        DescriptionList,
        Description,
    },
})
export default class AdvancedDetail extends Vue {

    private operationkey: string = 'tab1';

    private advancedOperation1: any[] = [];
    private advancedOperation2: any[] = [];
    private advancedOperation3: any[] = [];

    private operationTabList: any[] = [{
            key: 'tab1',
            tab: '操作日志一',
        },
        {
            key: 'tab2',
            tab: '操作日志二',
        },
        {
            key: 'tab3',
            tab: '操作日志三',
        },
    ];

    private columns = [{
            title: '操作类型',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: '操作人',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '执行结果',
            dataIndex: 'status',
            key: 'status',
            customRender: this.statusRender,
        },
        {
            title: '操作时间',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
        },
        {
            title: '备注',
            dataIndex: 'memo',
            key: 'memo',
        },
    ];

    private mounted(): void {
        axios.get('/api/profile/advanced').then((res: any) => {
            const data = res.data;
            this.advancedOperation1 = data.advancedOperation1;
            this.advancedOperation2 = data.advancedOperation2;
            this.advancedOperation3 = data.advancedOperation3;
        });
    }

    private handleOperationTabChange(key: string) {
        this.operationkey = key;
    }

    private statusRender(text: string) {
        if (text ===  'agree') {
            // tslint:disable-next-line:no-angle-bracket-type-assertion
            return <a-badge status = 'success' text = '成功' />;
        }
        // tslint:disable-next-line:no-angle-bracket-type-assertion
        return <a-badge status = 'error' text = '驳回' />;
    }


}
